export default __webpack_public_path__ + "static/media/error.d32b431f.png";